import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface InactivityWarningProps {
  open: boolean;
  secondsLeft: number;
  onStayActive: () => void;
  onLogout: () => void;
}

const InactivityWarning: React.FC<InactivityWarningProps> = ({
  open,
  secondsLeft,
  onStayActive,
  onLogout,
}) => {
  const { t } = useTranslation('modals');
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}m ${seconds.toString().padStart(2, '0')}s`
    : `${seconds}s`;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onLogout} disableEscapeKeyDown>
      <DialogTitle sx={{ fontWeight: 700 }}>{t('inactivity.title')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('inactivity.message', { time: timeDisplay })}
        </Typography>
        <Typography sx={{ mt: 1, color: 'text.secondary' }}>
          {t('inactivity.helper')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onLogout} color="inherit">
          {t('inactivity.logout')}
        </Button>
        <Button onClick={onStayActive} variant="contained" color="primary">
          {t('inactivity.stayLoggedIn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactivityWarning;
